<template>
  <BaseConfirmDialog
    class="[&_[data-pc-name=rejectbutton]]:underline-button w-fit min-w-80 max-w-[40rem]"
  >
    <template #message="slotProps">
      <div class="flex w-full items-center justify-start gap-3">
        <i v-if="slotProps.message.icon" :class="slotProps.message.icon" class="text-3xl"></i>
        <p>{{ slotProps.message.message }}</p>
      </div>
    </template>
  </BaseConfirmDialog>
</template>
